export class DatosContacto { 
    correoElectronico: string;
    celular: string;
    telefono: string;
    
    static instance() {
      return new this();
    }
};